import React from 'react';
import { chipColorMap, StyledChip } from './styles';

type ChipColor = keyof typeof chipColorMap;

interface ChipProps {
  label: React.ReactNode;
  color: ChipColor;
}

const Chip = (props: Readonly<ChipProps>) => {
  const { label, color } = props;

  return (
    <StyledChip color={color}>
      <strong>{label}</strong>
    </StyledChip>
  );
};

export default Chip;
